import { useEffect, useState } from 'react';

import { getServiceWorkerRegistration, updateServiceWorker as updateSW } from './registerServiceWorker';

export interface UseServiceWorkerReturn {
    isUpdateAvailable: boolean;
    updateServiceWorker: () => void;
    isOffline: boolean;
    registration: ServiceWorkerRegistration | undefined;
    isSupported: boolean;
}

export const useServiceWorker = (): UseServiceWorkerReturn => {
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const [isOffline, setIsOffline] = useState(!navigator.onLine);
    const [registration, setRegistration] = useState<ServiceWorkerRegistration | undefined>();
    const isSupported = 'serviceWorker' in navigator;

    useEffect(() => {
        // Get the service worker registration
        getServiceWorkerRegistration().then(setRegistration);

        // Listen for online/offline events
        const handleOnline = () => { setIsOffline(false); };
        const handleOffline = () => { setIsOffline(true); };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Listen for custom SW update event
        const handleUpdateAvailable = () => {
            console.log('Update available event received');
            setIsUpdateAvailable(true);
        };

        window.addEventListener('sw-update-available', handleUpdateAvailable);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('sw-update-available', handleUpdateAvailable);
        };
    }, []);

    const updateServiceWorker = () => {
        updateSW();
        setIsUpdateAvailable(false);
    };

    return {
        isUpdateAvailable,
        updateServiceWorker,
        isOffline,
        registration,
        isSupported,
    };
};
